/**
 * Utility functions for consistent height calculations across the application
 */

/**
 * Get responsive height calculation for main content areas
 * @param isMobile - Whether the current viewport is mobile
 * @returns CSS height value as string
 */
export const getResponsiveHeight = (isMobile: boolean): string => {
  return isMobile 
    ? 'calc(100vh - 200px)'  // Mobile: less space needed
    : 'calc(100vh - 300px)'; // Desktop: more space needed
};

/**
 * Get responsive height calculation for chat/conversation areas
 * @param isMobile - Whether the current viewport is mobile
 * @returns CSS height value as string
 */
export const getChatHeight = (isMobile: boolean): string => {
  return isMobile 
    ? 'calc(100vh - 240px)'  // Mobile: accounts for header, tabs, and chat input area
    : 'calc(100vh - 300px)'; // Desktop: consistent with main content
};
